var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.814 4.48a.516.516 0 0 0-.12-.493.508.508 0 0 0-.507-.133l-1.853.547-1.853-.547a.516.516 0 0 0-.494.12.486.486 0 0 0-.12.493l.534 1.867-.547 1.853c-.053.174 0 .36.12.494.133.133.32.173.493.12l1.867-.534 1.853.547c.054.013.094.027.147.027a.54.54 0 0 0 .36-.147.486.486 0 0 0 .12-.493l-.547-1.867.547-1.853zM13.151 19.195a.828.828 0 0 0-.192-.791.78.78 0 0 0-.79-.193l-2.993.855-2.972-.876a.828.828 0 0 0-.79.192.78.78 0 0 0-.193.791l.855 2.993-.876 2.971a.828.828 0 0 0 .192.79.78.78 0 0 0 .791.193l2.971-.876 2.971.876c.065.022.15.022.236.022a.866.866 0 0 0 .577-.236.78.78 0 0 0 .192-.79l-.855-2.95.876-2.971zM26.118 11.349c.1-.325 0-.675-.225-.925a.911.911 0 0 0-.924-.225l-3.475 1.025-3.474-1.025a.968.968 0 0 0-.924.225c-.25.25-.325.6-.225.925l1.024 3.474-1.024 3.474c-.1.325 0 .675.225.925.25.25.6.325.924.225l3.474-1.025 3.475 1.025a.937.937 0 0 0 .274.025c.25 0 .475-.1.675-.275.25-.25.325-.6.225-.925l-1.05-3.45 1.025-3.473z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon06);
export default __webpack_public_path__ + "static/media/icon-06.838ea2beccb0668b7e31fdc1e1bcae57.svg";
export { ForwardRef as ReactComponent };